<template>
    <div>  
         <main class="main ">
            <div class="bredcumb">
                <div class="container">
                    <ul>
                        <!-- <router-link  :key="index" v-for="(breadcrumb, index) in $store.state.breadcrumb"  tag="li" :to="breadcrumb.path"><a>{{breadcrumb.name}}</a></router-link> -->
                        <li><router-link to="/index"><a href="/index">首頁</a></router-link></li>
                        <li>鯨選課程</li>
                    </ul>
                </div>
            </div>

            <div class="bodyContent">
                <div class="container">
                    <!-- <section class="conditionSection">
                        <fieldset>
                            <legend>排序：</legend>
                            <div class="inputText">
                                <select name="" id="">
                                    <option selected="selected" value="%">依上架時間</option>
                                    <option value="01">依更新時間</option>
                                    <option value="02">依熱門排序</option>
                                </select>
                            </div>
                        </fieldset>
                    </section> -->
                    <section class="normalList">
                        <ul class="slick_list course_style2">
                            <!-- <li>
                                <figure>
                                    <div class="graphic"><img src="images/sample/course_1.jpg"></div>
                                </figure>
                                <figcaption>
                                    <h3>寶寶怎麼養才好</h3>
                                    <b>葉寶寶</b>
                                </figcaption>
                                <a href="course.html" class="fullLink" title="寶寶怎麼養才好">詳細內容</a>
                            </li> -->
 
                                   
                              <li v-for="(classDatas,$index) in classData"  @click="channelClickListener (classDatas, $index)"  >

                                    <figure>
                                        <div class="graphic"><img v-bind:src="classDatas.imgCover"></div>
                                        
                                    </figure>
                                    <figcaption>
                                        <h3>{{classDatas.title}}</h3>
                                        <b>{{classDatas.author.title}}</b>
                                    </figcaption>
                                <router-link v-bind:to="'/channel/'+classDatas.id" > <a :href="'/channel/'+classDatas.id" class="fullLink"></a></router-link>
                                    <!-- <a  class="fullLink" title="經理的面具：掌握管理的情境">詳細內容</a> -->
                               </li>

                          

                        </ul>
                    </section>
                    
                    
                </div>
            </div>


        </main>

    </div>    
</template>

<script>
export default {
    name: 'async',
    metaInfo () {
      return {
        
        title: '鯨選課程 | 一刻鯨選',
        meta: [
            // OpenGraph data (Most widely used)
            {property: 'og:title', content: '鯨選課程 | 一刻鯨選'},
            {property: 'og:site_name', content: '鯨選課程 | 一刻鯨選'},
            // The list of types is available here: http://ogp.me/#types
            {property: 'og:type', content: 'website'},
            // Should the the same as your canonical link, see below.
            {property: 'og:url', content: window.location.toString()},
            {property: 'og:image', content: this.$store.state.urlDomain+'/static/logo.jpg'},
            // Often the same as your meta description, but not always.
            {property: 'og:description', content: '提供豐富多元內容，精心打造，時刻陪伴！'},
        
        ]
      }
    },
  
 data(){
    return {
       classData: [],
    }
  },
  created() {

    this.axios
       .get(this.$store.getters.baseURL + 'channels?per_page=1000')
      .then(response => {
            this.classData = response.data.data;
          

      })
      .catch(error => console.log("log:"+error));
  },
   methods: {
        channelClickListener (item, index) {
        // alert(item.id);
        let id = item.id;
// 　　　　 this.$router.push({ path: "/course" });
        // this.$store.commit('courseId', id)
        this.$router.push({ path: "/channel/"+id, params: { id } });
　　　　},
        changePage(page){
        this.$router.replace({ path: "/"+page});

        }

　　},
    mounted() {
        $( "body" ).removeClass('index');
      }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/views/CourseList.vue